<template>
    <v-container fluid>
      <v-card>
        <v-fab-transition>
          <v-btn
            v-show="true"
            color="green"
            fab
            dark
            absolute
            top
            right
            @click.stop="openStallholderDialog()"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-fab-transition>
        <v-card-title>
          <v-row>
            <v-col>
              Stallholders
            </v-col>
            <v-col>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                v-on:input="debounceInput"
                clearable
                @click:clear="fetchStallholders()"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-select
                v-model="filter.stallholder_type"
                :items="getStallholderTypes"
                clearable
                label="Stallholder Type"
                item-text="label"
                item-value="name"
              ></v-select>
            </v-col>
            <v-col>
              <v-select
                :items="$store.state.categories"
                label="Category"
                clearable
                v-model="filter.category"
                item-value="id"
                item-text="name"
            ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col align="right" class="pt-0 px-4">
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn @click="getExcel(`/wisdom-markets/v1/stallholders/download/?${getFilterParamsString()}`)" color="success" fab small dark v-on="on" :loading="downloadsLoading.includes(`/wisdom-markets/v1/stallholders/download/?${getFilterParamsString()}`)">
                    <v-icon>mdi-file-download</v-icon>
                  </v-btn>
                </template>
                <span>{{ Object.keys(params).length > 0 ? `Download Stallholder Search Results` : `Download All Stallholders` }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-card-text>
        <v-data-table
          :headers="headers"
          :items="tableData"
          :options.sync="options"
          :server-items-length="totalItems"
          :loading="isLoading"
          :sort-by.sync="sortby"
          :sort-desc.sync="sortDesc"
          :must-sort=true
          :footer-props = "{
            'items-per-page-options': [20, 50, 100]
          }"
        >
          <template v-slot:item.actions="{ item }">
            <v-menu bottom left>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-on="on"
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click.stop="openStallholderDialog(item.id)">
                  <v-list-item-title>Edit Stallholder</v-list-item-title>
                </v-list-item>
                <v-list-item :to="`/stallholders/${item.id}`">
                  <v-list-item-title>View Stallholder Bookings</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>

          <template v-slot:item.stall_name="{item}">
            <button text @click="$router.push('stallholders/'+item.id)">{{ item.stall_name }}</button>
          </template>

          <!-- Stallholder Type -->
          <template v-slot:item.stallholder_type="{ item }">
            <stallholder-type-icon :type="item.stallholder_type"></stallholder-type-icon>
          </template>

          <template v-slot:item.email="{ item }">
            <mailto-btn :email="item.email"></mailto-btn>
            {{ item.email }}
          </template>
        </v-data-table>
      </v-card>

      <StallholderDialog
        :dialogVisible="isStallholderDialogVisible"
        :selectedStallholder="selectedStallholder ? selectedStallholder : false"
        @close="closeStallholderDialog"
        @update="updateStallholdersList"
        @create="fetchStallholders"
      />

      <v-dialog
        v-model="savingDialog"
        persistent
        width="300"
      >
        <v-card
          color="primary"
          dark
        >
          <v-card-text class="pt-5">
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
</template>



<script>

import axios from 'axios';
import { mapGetters } from 'vuex'
import StallholderDialog from '../components/StallholderDialog';
import StallholderTypeIcon from '../components/StallholderTypeIcon';
import MailtoBtn from '../components/MailtoBtn';
import debounce from 'lodash/debounce'
import excelDownload from '../js/excelDownloadMixin'

export default {
  data() {
    return {
      search: '',
      datemenu: false,
      isStallholderDialogVisible: false,
      headers: [
        { text: 'Business Name', value: 'stall_name' },
        { text: 'Email', value: 'email' },
        { text: 'Type', value: 'stallholder_type', sortable: false },
        { text: 'Category', value: 'stallholder_category',  align: ' d-none' }, // ' d-none' hides the column but keeps the search ability (note: does not get hidden for mobile responsive layout)
        { text: 'Phone', value: 'phone',  align: ' d-none' },
        { text: 'Full Name', value: 'full_name',  align: ' d-none' },
        { text: '', value: 'actions', sortable: false, align: 'right'},
      ],
      sortby: 'stall_name',
      sortDesc: false,
      savingDialog: false,
      selectedStallholderId: false,
      isLoading: true,
      items: [],
      totalItems: 0,
      options: {
        itemsPerPage: 20,
        page: 1
      },
      filter: {
        stallholder_type: '',
        category: '',
      },
    }
  },
  components: {
    StallholderDialog,
    StallholderTypeIcon,
    MailtoBtn
  },
  mixins: [ excelDownload ],
  watch: {
    options: {
      handler() {
        this.fetchStallholders();
      },
      deep: true
    },
    filter: {
      handler() {
        console.log('watching filter var');
        this.fetchStallholders();
      },
      deep: true
    }
  },
  methods: {
    openStallholderDialog (id) { 
      this.isStallholderDialogVisible = true
      this.selectedStallholderId = id;
    },
  
    closeStallholderDialog () { 
      this.isStallholderDialogVisible = false;

      // wait half a sec, before resetting data (otherwise we see the stall name cleared in the booking dialog before the dialog fully transitions)
      setTimeout(() => {
       this.selectedStallholderId = false;
      }, 500)  
    },
    fetchStallholders() {
      return new Promise((resolve, reject) => {
        const { sortBy, sortDesc, page, itemsPerPage } = this.options;

        let order = (sortDesc.length === 1 && sortDesc[0] == true) ? 'desc' : 'asc'

        let query = `/wisdom-markets/v1/stallholders/?`+
          `page=${page}` +
          `&orderby=${sortBy}`+
          `&order=${order}` +
          `&per_page=${itemsPerPage}`;

        query += `&`+this.getFilterParamsString();

        // Object.keys(this.filter).forEach(prop => {
        //   if(this.filter[prop] && this.filter[prop] != '')
        //     query += `&${prop}=${this.filter[prop]}`;
        // });

        this.isLoading = true;

        axios.get(query, {
          headers: {
            'Authorization': `Bearer ${this.$store.state.accessToken}`,
          },
        })
        .then( (response) => {
          let items = response.data;
          const totalItems = parseInt(response.headers['x-wp-total']);
          console.warn({totalItems})

          this.items = items;
          this.totalItems = totalItems;
          this.isLoading = false;

          resolve();

        })
        .catch((error) => {
          // console.log(error);
          // console.log("why the!!!!!");
          this.isLoading = false;
          reject(`Error: ${error}`);
        })
      });
    },
    updateStallholdersList(payload){
      console.warn({payload})

      let index = this.items.findIndex(item => item.id===payload.id);

      if (index !== -1) 
       this.items.splice(index, 1, payload); 
    },
    debounceInput: debounce(function (e) {
      this.options.page = 1; //reset
      this.fetchStallholders();
    }, 500),
    getFilterParamsString(){
      return Object.keys(this.params).map(key => `${key}=${this.params[key]}`).join('&');
    }
  },
  computed: {
    ...mapGetters([
      // 'getStallholderById',
      'getCategoryById',
      'getStallholderTypes'
    ]),
    selectedStallholder() {
      if (!this.selectedStallholderId) return false;
      return this.items.find( item => this.selectedStallholderId == item.id)
    },
    tableData(){
      return this.items.map( stallholder => {
        let category = this.getCategoryById(stallholder.category);
        if(category)
          stallholder.stallholder_category = category.name;

        stallholder.full_name = stallholder.first_name+' '+stallholder.last_name  

        return stallholder;
      });
    },
    params() {
      let params = {};
      if(this.search) {
        let search = encodeURIComponent(this.search.trim().toLowerCase());
        if(search)
          params.s = search;
      }

      Object.entries(this.filter).map(entry =>  entry[1] ? params[entry[0]] = entry[1] : null)

      return params;
    },
  },
  mounted(){
    console.log('mount')
    //this.$store.dispatch('getStallholders', { });
    this.$store.dispatch('getStallholderCategories', { });
  }
}
</script>

<style>

</style>